import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import ReduxThunk from 'redux-thunk'
import authReducer from '../reducers/authReducer';
import leagueReducer from "../reducers/leagueReducer";
import matchesReducer from "../reducers/matchesReducer";
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const rootReducer = combineReducers({
  auth: authReducer,
  matches:matchesReducer,
  leagues:leagueReducer,
});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(ReduxThunk))
);

export default store;